//@flow
import React from 'react';
import { Helmet } from 'react-helmet';
import capitalize from 'lodash.upperfirst';
import FiltersResult from '../../Filters/components/filtersResult.react';
import OtherCategories from '../../Categories/components/OtherCategories.react';
import CatalogBanner from '../../Catalog/components/CatalogBanner.react';
import CategoryFrame from './CategoryFrame.react';
import GoogleTagManager from '../../Utils/gtm-interface';

import type { List } from 'immutable';
import type { Location } from 'react-router';
import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type MembershipModel from '../../Stores/Membership/membershipModel';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type ProductModel from '../../Stores/Products/productModel';
import type { Filter, FilterCategories } from '../../Stores/Filters/filtersStoreClass';

type Props = {
  allFilters:FilterCategories,
  category:CategoryModel,
  categories:CategoriesCollection,
  filters:Filter[],
  products:ProductsCollection,
  quote:QuoteModel,
  quoteItems:QuoteItemsCollection,
  stock:StockCollection,
  membership:MembershipModel,
  quoteTotals:QuoteTotalsModel,
  customer:CustomerModel,
  isMember:boolean,
  inUS:boolean,
  stockReminders:List<string>,
  userCountry:string,
  membershipPlan:MembershipPlanModel,
  location:Location,
  inFreeBox:boolean,
  isOffice?:boolean,
};

export default class Category extends React.Component<Props> {
  componentDidMount() {
    const skus = this.props.category.getProductsSkus();

    GoogleTagManager.generalEvent({
      event: 'pageView',
      page: 'category',
      visibleSkus: skus,
    });
  }

  _getFilteredProducts():ProductModel[] {
    const prodSkus = this.props.category.getProductsSkus();
    return this.props.products.getFilteredProducts(this.props.filters, prodSkus);
  }

  //hide the banner if in free box promo
  _getBanner() {
    if (this.props.inFreeBox) return null;
    return (
      <CatalogBanner />
    );
  }

  _getHeader() {
    return (
      <header className="category-header">
        <h1 className="category-name">{capitalize(this.props.category.getName())}</h1>
      </header>
    );
  }

  //Don't show food categories on category pages
  _getTrimmedCategoryFilters():FilterCategories {
    const trimmedFilters = Object.assign({}, this.props.allFilters);
    delete trimmedFilters.CATEGORIES;
    return trimmedFilters;
  }

  render() {
    return (
      <CategoryFrame
        banner={this._getBanner()}
        header={this._getHeader()}
        filteredProducts={this._getFilteredProducts()}
        allFilters={this._getTrimmedCategoryFilters()}
        filters={this.props.filters}
        products={this.props.products}
        quote={this.props.quote}
        quoteItems={this.props.quoteItems}
        quoteTotals={this.props.quoteTotals}
        isMember={this.props.isMember}
        inUS={this.props.inUS}
        membershipPlan={this.props.membershipPlan}
        categories={this.props.categories}
        category={this.props.category}
        customer={this.props.customer}
        isOffice={this.props.isOffice}
      >
        <Helmet
          link={[
            {
              rel: 'canonical',
              href: `https://naturebox.com${this.props.location.pathname}`,
            },
          ]}
        />

        <FiltersResult
          products={this.props.products}
          filters={this.props.filters}
          validSkus={this.props.category.getProductsSkus()}
          stock={this.props.stock}
          quote={this.props.quote}
          quoteItems={this.props.quoteItems}
          quoteTotals={this.props.quoteTotals}
          categories={this.props.categories}
          customer={this.props.customer}
          stockReminders={this.props.stockReminders}
          userCountry={this.props.userCountry}
          membershipPlan={this.props.membershipPlan}
          isOffice={this.props.isOffice}
        />

        <OtherCategories
          categories={this.props.categories.getOtherCategories()}
          currentCategory={this.props.category}
          isOffice={this.props.isOffice}
        />
      </CategoryFrame>
    );
  }
}
